module.exports = __webpack_public_path__ + "img/logo.ef1c49c5.png";